export enum PaperHeights {
  creditsFrom1099px = "446px",
  resourceDownloads = "232px",
  newsHeightFrom1099 = "1312px",
  xxs = "300px",
  xs = "364px",
  sm = "370px",
  medium = "422px",
  large = "458px",
  xlarge = "528px",
  xxlarge = "572px",
  xxxlarge = "701px"
}

export enum PaperContentHeights {
  header = "60px",
  marginBottom = "24px",
  bannerSize = "54px",
  singleLegendCard = "74px"
}

export enum DashboardCardNames {
  CompanyCards = "Company cards"
}

export enum CONNECTIVITY_TABS {
  Devices = "devices",
  CompanyCards = "company cards"
}
